import {
  Select
} from '@cloudscape-design/components';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../pages/context/GlobalStateContext';


interface SelectGMTProps {
  value?: number;
  width?: number;
  onSelect?: (selected: number | null) => void;
  readonly?: boolean;
}

const timezoneOptions = [
  { value: "-11", label: "GMT -11:00" },
  { value: "-10", label: "GMT -10:00" },
  { value: "-9.5", label: "GMT -09:30" },
  { value: "-9", label: "GMT -09:00" },
  { value: "-8", label: "GMT -08:00" },
  { value: "-7", label: "GMT -07:00" },
  { value: "-6", label: "GMT -06:00" },
  { value: "-5", label: "GMT -05:00" },
  { value: "-4", label: "GMT -04:00" },
  { value: "-3.5", label: "GMT -03:30" },
  { value: "-3", label: "GMT -03:00" },
  { value: "-2", label: "GMT -02:00" },
  { value: "-1", label: "GMT -01:00" },
  { value: "0", label: "UTC" },
  { value: "1", label: "GMT +01:00" },
  { value: "2", label: "GMT +02:00" },
  { value: "3", label: "GMT +03:00" },
  { value: "3.5", label: "GMT +03:30" },
  { value: "4", label: "GMT +04:00" },
  { value: "4.5", label: "GMT +04:30" },
  { value: "5", label: "GMT +05:00" },
  { value: "5.5", label: "GMT +05:30" },
  { value: "5.75", label: "GMT +05:45" },
  { value: "6", label: "GMT +06:00" },
  { value: "6.5", label: "GMT +06:30" },
  { value: "7", label: "GMT +07:00" },
  { value: "8", label: "GMT +08:00" },
  { value: "8.75", label: "GMT +08:45" },
  { value: "9", label: "GMT +09:00" },
  { value: "9.5", label: "GMT +09:30" },
  { value: "10", label: "GMT +10:00" },
  { value: "10.5", label: "GMT +10:30" },
  { value: "11", label: "GMT +11:00" },
  { value: "12", label: "GMT +12:00" },
  { value: "12.75", label: "GMT +12:45" },
  { value: "13", label: "GMT +13:00" },
  { value: "14", label: "GMT +14:00" },
];


const SelectGMT: React.FC<SelectGMTProps> = (props) => {
  const {
    value,
    width = 200,
    readonly,
    onSelect
  } = props;

  const { data } = useGlobalState();
  if (!data || !data.gates) return <></>;

  // State for Single Selection (holds the selected object)
  const [selectedOption, setSelectedOption] = useState<any>(null);


  // --- Initialization & Value Sync Effect ---

  useEffect(() => {
    if (value === undefined || value === null) {
      setSelectedOption(null);
      return;
    }

    // SINGLE MODE: Value is a number (ID)
    const id = value as number;
    const match = timezoneOptions.find(v => v.value === id.toString()) || null;
    setSelectedOption(match);
  }, [value, timezoneOptions]);




  const placeholder = "Seleccionar zona horaria";
  const wrapperStyle: React.CSSProperties = {
    width: width > 0 ? `${width}px` : '100%'
  };
  return (
    <div style={wrapperStyle}>
      <Select
        readOnly={readonly}
        placeholder={placeholder}
        selectedOption={selectedOption}
        options={timezoneOptions}
        onChange={(e) => {
          const selectedValue = e.detail.selectedOption as any;
          setSelectedOption(selectedValue);
          if (onSelect) {
            const selectedId = selectedValue?.value ? parseFloat(selectedValue.value) : null;
            (onSelect as (selected: number | null) => void)(selectedId);
          }
        }}
      />
    </div>
  );
};
export default SelectGMT;